import { KoalaIcon } from './KoalaIcon';

/**
 * author: Claire Casaregola
 * id 180CACBF-4272-4D07-B9A0-63A5625DCB0C
 * name koala
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/koala.svg
 * tags
 * - Animal 
 */
export const EmoticonKoalaIcon = KoalaIcon;
export default EmoticonKoalaIcon